import React from "react";
import { Box,Typography } from "@mui/material";

const BenefitsFeature=({number,title,mainDescription,description,image})=>(
 <Box className="benefit-feature" sx={{
   width:"98%",
   left:"1%",
   height:"custom.layoutSizes.benefits.featureHeight",
   bgcolor:"background.paper",
   border: (theme) => `0.5px solid ${theme.custom.colors.alpha.white[55]}`,
   borderRadius:"24px",
   boxShadow: (theme) => `0 24px 60px rgba(0, 0, 0, 0.35), 0 8px 20px rgba(0, 0, 0, 0.2)`,
   overflow:"hidden",
 }}>
  <Box className="benefit-feature-image" sx={{
    position:"absolute",
    inset:0,
    zIndex:0,
  }}>
   <img
    src={image}
    alt={title}
    style={{
      width:"100%",
      height:"100%",
      objectFit:"cover",
      display:"block",
    }}
   />
  </Box>

  <Box className="benefit-feature-content" sx={{
    position:"relative",
    zIndex:2,
  }}>
   <Typography className="benefit-feature-number" sx={{
     color:"custom.colors.home.brandRed",
     fontSize:{xs:"11px",md:"13px"},
     fontWeight:700,
     letterSpacing:"0.12em",
     mb:"8px"
   }}>
    {String(number).padStart(2,"0")}
   </Typography>

   <Typography className="benefit-feature-title" sx={{
     color:"custom.colors.home.brandDark",
     fontSize:{xs:"22px",md:"28px",lg:"32px"},
     fontWeight:800,
     lineHeight:1.1,
     m:0
   }}>
    {title}
   </Typography>

   <Typography className="benefit-feature-description" sx={{
     color:"custom.colors.home.grayBlue",
     fontSize:{xs:"14px",md:"17px",lg:"18px"},
     lineHeight:1.5,
     maxWidth:"520px",
     mt:"18px"
   }}>
    {mainDescription}
   </Typography>

   <Box sx={{
     display:"inline-flex",
     alignItems:"center",
     mt:"20px",
     px:"16px",
     py:"8px",
     border:"1px solid rgba(255,255,255,0.8)",
     borderRadius:"999px",
     bgcolor:"rgba(255,255,255,0.45)",
     backdropFilter:"blur(10px)",
     WebkitBackdropFilter:"blur(10px)",
     boxShadow:"0 2px 12px rgba(255,255,255,0.25)",
   }}>
    <Typography sx={{
      color:"custom.colors.home.brandDark",
      fontSize:{xs:"12px",md:"13px"},
      fontWeight:600,
      lineHeight:1.4,
    }}>
     {description}
    </Typography>
   </Box>
  </Box>
 </Box>
);

export default BenefitsFeature;